import {DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {getApiBaseForObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {postJSONPromise, patchJSONPromise} from 'util/Net';

export interface CreateTentacleParams {
  name: string;
}

export interface CreateJellyfishParams {
  name: string;
  description: string | null;
  folderId: string;
  tentacles: Array<CreateTentacleParams>;
}

export interface CreateJellyfishResponse {
  createdIds: Array<string>;
}

export function createJellyfish(jellyfish: CreateJellyfishParams): Promise<CreateJellyfishResponse> {
  const creates = [jellyfish];
  return postJSONPromise({url: getApiBaseForObjectType(DomainGraphType.JELLYFISH), data: {creates}});
}

export interface UpdateJellyfishParams {
  id: string;
  name?: string;
  description?: string | null;
}

export interface UpdateJellyfishResponse {
  updatedIds: Array<string>;
}

export function updateJellyfish(jellyfish: UpdateJellyfishParams): Promise<UpdateJellyfishResponse> {
  const updates = [jellyfish];
  return patchJSONPromise({url: `${getApiBaseForObjectType(DomainGraphType.JELLYFISH)}`, data: {updates}});
}
